import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { isEqual } from 'lodash';
import CategoriesHeader from './CategoriesHeader.jsx';
import CategoryFilters from './CategoryFilters.jsx';

const Filters = ({
  filtersData,
  resetAction,
  resetAllAction,
  resetDependencies,
}) => {
  const [selectedCategories, updateSelectedCategories] = useState({});
  const [selectedFilters, updateSelectedFilters] = useState({});

  const categories = filtersData.reduce(
    (acc, c) => ({ ...acc, [c.key]: true }),
    {}
  );

  const filters = filtersData.reduce((acc, category) => {
    const visibleFilters = category.filters
      .filter((filter) => !filter.disabled && !filter.hidden)
      .map((filter) => filter.key);

    return {
      ...acc,
      [category.key]: true,
      ...visibleFilters.reduce((acc, f) => ({ ...acc, [f]: true }), {}),
    };
  }, {});

  const areFiltersEqual = isEqual(filters, selectedFilters);

  const resetQueryParams = (filters) => {
    const paramsToReset = filters.reduce(
      (acc, item) => ({ ...acc, ...(item.resetQueryParams || []) }),
      {}
    );

    resetAction(paramsToReset);
  };

  const getCategoryByKey = (k) => {
    const category = filtersData.find((c) => c.key === k);
    return category || { filters: [] };
  };

  const onSelectCategory = (k) => {
    const category = getCategoryByKey(k);
    const { filters } = category;
    const alreadySelected = !!selectedCategories[k];

    updateSelectedCategories((prev) => ({ ...prev, [k]: !prev[k] }));
    updateSelectedFilters((prev) => {
      return {
        ...prev,
        ...filters.reduce(
          (acc, f) =>
            !f.disabled && !f.hidden
              ? { ...acc, [f.key]: !alreadySelected }
              : acc,
          {}
        ),
      };
    });

    alreadySelected && resetQueryParams(filters);
  };

  const onSelectFilter = (ck, fk) => {
    const category = getCategoryByKey(ck);
    const updatedFilterValue = !selectedFilters[fk];
    const categoryFilters = category.filters.map((f) => f.key);
    const areAnyFiltersSelected = categoryFilters.some(
      (f) => ({ ...selectedFilters, [fk]: updatedFilterValue })[f]
    );

    updateSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [fk]: updatedFilterValue,
    }));
    updateSelectedCategories((prevCategories) => ({
      ...prevCategories,
      [ck]: areAnyFiltersSelected,
    }));

    resetQueryParams([category.filters.find((f) => f.key === fk)]);
  };

  const onSelectAll = () => {
    updateSelectedCategories(!areFiltersEqual ? categories : {});
    updateSelectedFilters(!areFiltersEqual ? filters : {});

    areFiltersEqual && resetAllAction();
  };

  const setPreselected = () => {
    filtersData.forEach(({ key, preselectedFilterKeys }) => {
      if (preselectedFilterKeys) {
        updateSelectedCategories((prevCategories) => ({
          ...prevCategories,
          [key]: true,
        }));

        const preselectedKeys = preselectedFilterKeys.reduce(
          (acc, key) => ({ ...acc, [key]: true }),
          {}
        );

        updateSelectedFilters((prevFilters) => ({
          ...prevFilters,
          ...preselectedKeys,
        }));
      }
    });
  };

  useEffect(() => {
    updateSelectedCategories({});
    updateSelectedFilters({});
    setPreselected();
  }, [...resetDependencies]);

  return (
    <div className="component report-filters" style={{ paddingBottom: '14px' }}>
      <Row>
        <Col xs={12}>
          <CategoriesHeader
            filtersData={filtersData}
            selectedCategories={selectedCategories}
            selectedFilters={selectedFilters}
            allSelected={areFiltersEqual}
            onSelectCategory={onSelectCategory}
            onSelectAll={onSelectAll}
            onSelectFilter={onSelectFilter}
            resetAllAction={resetAllAction}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <CategoryFilters
            filtersData={filtersData}
            selectedCategories={selectedCategories}
            selectedFilters={selectedFilters}
            onSelectFilter={onSelectFilter}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Filters;
